import { render } from "./ContractCard.vue?vue&type=template&id=bd611098&scoped=true"
import script from "./ContractCard.vue?vue&type=script&lang=js"
export * from "./ContractCard.vue?vue&type=script&lang=js"

import "./ContractCard.vue?vue&type=style&index=0&id=bd611098&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd611098"]])

export default __exports__